import React from 'react'
import Common from './Common'
import rocket from './images/rocket.png'

function Home() {
  return (
    <>
       <Common 
        name= 'Grow Your Buisness With'
        imgsrc={rocket} 
        visit ='/service'
        btName = "Get Started" 
        />
    </>
  )
}

export default Home
